const DIALOG_ID = 'NotifyMeDialog-3dids';
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function getDialog(trigger) {
  const picker = trigger.closest('variant-picker') ?? document;
  const template = picker.querySelector('template[data-notify-template-3dids]');
  if (!template) return null;

  document.getElementById(DIALOG_ID)?.remove();
  const fragment = template.content.cloneNode(true);
  document.body.append(fragment);
  const dialog = document.getElementById(DIALOG_ID);
  bindDialog(dialog);
  return dialog;
}

function strings(dialog) {
  return dialog.querySelector('[data-notify-strings-3dids]')?.dataset ?? {};
}

function showMessage(dialog, text, state) {
  const message = dialog.querySelector('[data-notify-message-3dids]');
  if (!message) return;
  message.textContent = text;
  message.dataset.state = state;
  message.hidden = !text;
}

async function subscribe({ email, variantId, variantTitle, productId, productName }) {
  const storeId = window.REZ_DATA?.storeData?.id;
  if (!storeId) throw new Error('notify-me: REZ Back In Stock is not enabled');

  const response = await fetch('/apps/rez/bis/product', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      variant_id: Number(variantId),
      variant_title: variantTitle,
      store_id: storeId,
      product_name: productName,
      product_id: Number(productId),
      locale: window.Shopify?.locale ?? null,
      opt_in_marketing: false,
    }),
  });

  if (!response.ok) throw new Error(`notify-me: REZ responded ${response.status}`);
  return response;
}

function bindDialog(dialog) {
  const form = dialog.querySelector('[data-notify-form-3dids]');
  const submit = dialog.querySelector('[data-notify-submit-3dids]');
  const emailInput = dialog.querySelector('[data-notify-email-3dids]');
  const text = strings(dialog);

  dialog.querySelector('[data-notify-close-3dids]')?.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', () => {
    dialog.remove();
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = emailInput.value.trim();

    if (!EMAIL_PATTERN.test(email)) {
      showMessage(dialog, text.invalid, 'error');
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.focus();
      return;
    }

    emailInput.removeAttribute('aria-invalid');
    submit.setAttribute('aria-busy', 'true');
    showMessage(dialog, '', '');

    try {
      await subscribe({
        email,
        variantId: dialog.querySelector('[data-notify-variant-3dids]').value,
        variantTitle: dialog.querySelector('[data-notify-variant-title-3dids]').value,
        productId: dialog.querySelector('[data-notify-product-3dids]').value,
        productName: dialog.querySelector('[data-notify-product-name-3dids]').value,
      });
      showMessage(dialog, text.success, 'success');
      emailInput.disabled = true;
      submit.hidden = true;
    } catch (error) {
      console.warn(error);
      showMessage(dialog, text.error, 'error');
    } finally {
      submit.removeAttribute('aria-busy');
    }
  });
}

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-notify-open-3dids]') : null;
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  const dialog = getDialog(trigger);
  if (!dialog) return;

  const text = strings(dialog);
  dialog.querySelector('[data-notify-variant-3dids]').value = trigger.dataset.variantId ?? '';
  dialog.querySelector('[data-notify-variant-title-3dids]').value = trigger.dataset.variantTitle ?? trigger.dataset.value ?? '';
  const size = dialog.querySelector('[data-notify-size-3dids]');
  if (size) size.textContent = `${text.sizeLabel ?? ''} ${trigger.dataset.value ?? ''}`.trim();

  dialog.showModal();
  dialog.querySelector('[data-notify-email-3dids]')?.focus();
});
